import Highlight from '../Highlight';

import { trackEvent } from '@monofront/tracking';
import { HitProps, ICollection } from '@monofront/types';
import { useGlobalSearchContext } from '../../../../../../context/GlobalSearchContext';
import Link from 'next/link';
import { ALGOLIA_INSIGHTS_EVENT_NAME } from '@monofront/business/constants';

type ListCollectionProps = HitProps<ICollection>;

const ListCollection: React.FC<ListCollectionProps> = ({ hit, sendEvent }) => {
  const { setIsGlobalSearchResultsPanelOpen } = useGlobalSearchContext();

  return (
    <>
      <Link
        key={hit.objectID}
        href={`/collections/${hit.handle}`}
        passHref
        legacyBehavior
      >
        <a
          onClick={() => {
            sendEvent('click', hit, ALGOLIA_INSIGHTS_EVENT_NAME.CLICK_PRODUCT);

            setIsGlobalSearchResultsPanelOpen(false);

            trackEvent({
              type: 'LFSearchRecommendationClick',
              data: {
                recommendationType: 'collection',
                collectionName: hit.title,
                collectionSlug: `/collections/${hit.handle}`,
                isSearchEmpty: false,
              },
            });
          }}
          className="list-collection-suggestion tw-lf-button tw-lf-button-secondary tw-lf-button-sm tw-text-start"
        >
          <Highlight hit={hit} attribute="title" />
        </a>
      </Link>
      <style jsx>{`
        :global(.list-collection-suggestion) {
          margin-bottom: var(--space-2);
          display: inline-block;
          font-weight: var(--font-weight-light);
        }
      `}</style>
    </>
  );
};

export default ListCollection;
